// Components==============
import React, { createContext, useMemo, useState } from 'react';
import { ConfirmTypes, TranslateType } from 'typings';
// =========================

type GlobalConfirmContextType = {
  confirm: TranslateType;
  setConfirm: React.Dispatch<React.SetStateAction<TranslateType>>;
  confirmState: ConfirmTypes;
  setConfirmState: React.Dispatch<React.SetStateAction<ConfirmTypes>>;
  triggerClearConfirmFunction: boolean;
  setTriggerClearConfirmFunction: React.Dispatch<React.SetStateAction<boolean>>;
};

export const GlobalConfirmContext = createContext(
  {} as GlobalConfirmContextType
);

export default function GlobalConfirm({
  children,
}: {
  children: React.ReactNode;
}) {
  const [confirm, setConfirm] = useState<TranslateType>('');
  const [confirmState, setConfirmState] = useState<ConfirmTypes>('idle');
  const [
    triggerClearConfirmFunction,
    setTriggerClearConfirmFunction,
  ] = useState(false);

  const value = useMemo(
    () => ({
      confirm,
      setConfirm,
      confirmState,
      setConfirmState,
      triggerClearConfirmFunction,
      setTriggerClearConfirmFunction,
    }),
    [confirm, confirmState, triggerClearConfirmFunction]
  );

  return (
    <GlobalConfirmContext.Provider value={value}>
      {children}
    </GlobalConfirmContext.Provider>
  );
}
